import { useMemo } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import type { FlagConfiguration } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import type { ErrorCode } from '@atlassian/jira-issue-adjustments/src/controllers/issue-adjustments/actions/types';
import { getErrorFlagProperties } from './utils';

type PropsOld = {
	errorCode: ErrorCode | null;
};

type Props = {
	errorCode: ErrorCode;
	fieldName?: string;
} | null;

// remove useErrorFlagConfigOld with forge-ui-modifications-validation-errors-returned-to-app_hdzmw FF removal
export const useErrorFlagConfigOld = ({ errorCode }: PropsOld): FlagConfiguration | null => {
	const { formatMessage } = useIntl();
	const errorFlagConfig = useMemo(() => {
		if (errorCode === null) {
			return null;
		}
		const errorFlagProperties = getErrorFlagProperties(errorCode);
		return errorFlagProperties
			? ({
					type: 'error',
					title: formatMessage(errorFlagProperties.title),
					description: formatMessage(errorFlagProperties.message),
					isAutoDismiss: true,
				} as const)
			: null;
	}, [errorCode, formatMessage]);
	return errorFlagConfig;
};

export const useErrorFlagConfig = (errorProperties: Props): FlagConfiguration | null => {
	const { formatMessage } = useIntl();
	const errorFlagConfig = useMemo(() => {
		if (errorProperties === null) {
			return null;
		}
		const { errorCode, fieldName } = errorProperties;
		const errorFlagProperties = getErrorFlagProperties(errorCode);
		return errorFlagProperties
			? ({
					type: 'error',
					title: formatMessage(errorFlagProperties.title),
					description: formatMessage(
						errorFlagProperties.message,
						ff('forge-ui-modifications-validation-errors-returned-to-app_hdzmw')
							? {
									fieldName: fieldName ?? 'Unknown field',
								}
							: undefined,
					),
					isAutoDismiss: true,
				} as const)
			: null;
	}, [errorProperties, formatMessage]);
	return errorFlagConfig;
};
